import Inherit from '../../core/inherit';
import Constants from '../../data/constants';
import AuditorsDelegate from './auditors.delegate';
import ShelfController from '../../core/shelf.controller';
import { exportAuditorsExcel, exportAuditorsPdf } from '../../utils/auditorExport';

class AuditorsController extends Inherit(ShelfController, AuditorsDelegate) {
    async initialize() {
        if (this.isAuthenticated) {
            const auditors = await this.data.fetchUsersByUserType(Constants.USER_TYPES.AUDITOR);
            this.setState({ auditors, rows: auditors, loading: false });
        } else this.navigateLogin();
    }

    // Every store (assignments live on Store.auditor), fetched once per page visit on demand.
    async _loadStoresForExport() {
        if (this._exportStores) return this._exportStores;
        const stores = await this.data.fetchAllStores();
        this._exportStores = Array.isArray(stores) ? stores : [];
        return this._exportStores;
    }

    // Exports the auditors currently listed (the search filter applies) with all their PDVs.
    async exportAssignments(format) {
        const { onMessage } = this.props;
        const auditors = this.state.rows?.length ? this.state.rows : this.state.auditors;
        if (!auditors?.length) {
            onMessage('warning', 'No hay auditores para exportar');
            return;
        }
        this.setState({ exporting: format });
        try {
            const stores = await this._loadStoresForExport();
            const count = format === 'pdf' ? exportAuditorsPdf(auditors, stores) : exportAuditorsExcel(auditors, stores);
            onMessage('success', `Exportado: ${auditors.length} auditores, ${count} filas`);
        } catch (err) {
            console.error('❌ Auditor export failed:', err);
            onMessage('error', 'No se pudo generar la exportación');
        } finally {
            this.setState({ exporting: null });
        }
    }

    async removeAuditor(id) {
        const { onMessage } = this.props;
        const user = await this.data.updateUser(id, { active: false });

        if (user) {
            onMessage('success', 'Auditor eliminado correctamente');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else onMessage('error', 'Error al eliminar auditor');
    }
}

export default AuditorsController;
